<template>
  <div class="danger-zone">
    <h4 class="_heading">
      {{ $t('general.dangerZone') }}
    </h4>
    <m-divider class="_divider" />
    <slot />
  </div>
</template>

<script setup>
</script>

<style scoped lang="scss" type="text/scss">
  .danger-zone {
    ._heading {
      margin-bottom: 0;
      color: $font-color-primary;
    }

    ._divider {
      margin-top: .8rem;
      margin-bottom: 1.6rem;
    }
  }
</style>
